import { TemplatePageProps } from './types'
import { MatchNFlipEntity } from './entity'
import Icon from 'images/games/match-n-flip/icon.png'
import Detail1 from 'images/games/match-n-flip/detail1.png'
import Footer from 'images/games/match-n-flip/footer.png'
import { Pocket7GamesSwiper } from './pocket7games'
import {
  DominoesLink,
  DunkShotLink,
  NumbersBlitzLink,
  PlaySolitaireOnlineLink,
  Pocket7GamesLink,
  PoolClashLink,
  TwentyOneGoldLink,
} from '../../components'

export const MatchNFlipDetail: TemplatePageProps = {
  entity: {
    ...MatchNFlipEntity,
    logo: Icon,
    title: <>Match n Flip: A Fun and Fast Uno Game Online Experience </>,
    description: (
      <>
        Ready for a fresh spin on your favorite <strong>Uno game</strong>? Match n Flip—found in the Pocket7Games
        app—delivers fast-paced 1v1 and multiplayer action with rules inspired by the classic. Race the clock, score
        points, and play for fun or money. Download now and jump into various game modes to <strong>play Uno</strong>{' '}
        anytime!
      </>
    ),
  },
  swiper: Pocket7GamesSwiper,
  content: [
    {
      title: <>How to Play Uno in Match n Flip</>,
      description: (
        <>
          Match n Flip combines the best parts of the Uno game for mobile play. Match cards by number or color to clear
          your board and score points. Enjoy features like “Undo” for second chances and “Split” to move half of your
          cards to an empty column for strategic resets, making gameplay dynamic and engaging.
          <br />
          <br />
          Earn Combo Bonuses rewards for clearing multiple cards consecutively. Magic Cards flip an extra card per pile,
          and wildcards match any color or number, just like classic <strong>Uno games</strong>. Whether building your
          skills or just wanting to <strong>play Uno</strong>, this game makes every round competitive and engaging.
        </>
      ),
      image: Detail1,
    },
    {
      title: <>Play Uno Anytime, Anywhere with Pocket7Games</>,
      description: (
        <>
          Match n Flip brings a joyful twist to <strong>uno game online</strong>. It’s competitive, fun, and easy to
          pick up—a game that keep you smiling. Craving more excitement? The{' '}
          <Pocket7GamesLink>Pocket7Games app</Pocket7GamesLink> is packed with card games like{' '}
          <PlaySolitaireOnlineLink /> and <TwentyOneGoldLink />, plus <PoolClashLink />, <DunkShotLink />,{' '}
          <NumbersBlitzLink />, <DominoesLink />, and more for endless fun!
        </>
      ),
    },
  ],
  footer: { image: Footer },
} as TemplatePageProps
